const carrierEmailProviderForm = {
	urlGET: "api/profile/carriers/:carrierId/email-providers/:providerId",
	urlPOST: "api/profile/carriers/:carrierId/email-providers",
	urlDELETE: "api/profile/carriers/:carrierId/email-providers/:providerId",
	urlPUT: "api/profile/carriers/:carrierId/email-providers/:providerId",
	idKey: "_id",
	triggerEvent: "profileRevision",
	size: "max-w-lg",
	header: {
		create: { label: "Add Email Provider" },
		delete: { label: "Delete Email Provider" },
		edit: { label: "Edit Email Provider" },
		view: { label: "Email Provider Details" },
		//toggle: { label: "Change Provider Status" },
	},
	messages: { edit: { success: "Saved Succesfully" }, create: { sameAs: "edit" } },
	content: {
		view: { sameAs: "edit" },
		create: {
			items: [
				/*{
					key: "server_name",
					type: "text",
					label: "Host",
					required: true,
					description: "Your Email Server Name. Ex. smtp.outlook.com",
				},
				{
					key: "port",
					type: "text",
					label: "Port",
					required: true,
					description: "Typically 587",
				},*/
				{
					key: "username",
					type: "email",
					label: "Email",
					required: true,
				},
				{
					key: "password",
					type: "password",
					label: "Password",
					required: true,
					description: "The email account password.",
				},
				{
					type: "action",
					action: "SUBMIT",
					label: "Save",
				},
			],
		},
		edit: {
			items: [
				/*{
					key: "server_name",
					type: "text",
					label: "Host",
					required: false,
					description: "Your Email Server Name. Ex. smtp.outlook.com",
					defaultValue: "smtp.outlook.com",
				},
				{
					key: "port",
					type: "text",
					label: "Port",
					required: false,
					description: "Typically 587",
					defaultValue: "587",
				},*/
				{
					key: "username",
					type: "email",
					label: "Email",
					required: true,
				},
				{
					key: "password",
					type: "password",
					label: "Password",
					required: true,
					description: "The email account password.",
				},
				{
					type: "action",
					action: "SUBMIT",
					label: "Update",
				},
			],
		},
		delete: {
			items: [
				{
					type: "message",
					builder: (item) =>
						`Would you like to permanently delete the email provider '${item.authentication.username}'?`,
				},
				{
					type: "group",
					content: {
						items: [
							{ type: "action", action: "CANCEL" },
							{
								type: "action",
								action: "DELETE",
							},
						],
					},
				},
			],
		},
		/*toggle: {
			items: [
				{
					type: "message",
					builder: (item) =>
						`Do you want to ${item.enabled ? "disable" : "enable"} the email provider '${
							item.authentication.username
						}'?`,
				},
				{
					type: "group",
					content: {
						items: [
							{ type: "action", action: "CANCEL" },
							{
								type: "action",
								action: "SUBMIT",
								label: (item) => (item.enabled ? "Disable" : "Enable"),
								button: { alwaysEnabled: true },
							},
						],
					},
				},
			],
		}
        */
	},
};

export default carrierEmailProviderForm;
